// Metafield Extractor
// This script extracts the value from a JSON metafield

document.addEventListener('DOMContentLoaded', function() {
  const metafieldElements = document.querySelectorAll('.product-card__metafield-text');
  
  metafieldElements.forEach(element => {
    // Get the raw metafield data from the data attribute
    const metafieldData = element.getAttribute('data-metafield-value');
    
    if (metafieldData && metafieldData.includes('"value":"')) {
      try {
        // Extract just the text between value:"" using regex
        const valueMatch = metafieldData.match(/"value":"([^"]+)"/);
        if (valueMatch && valueMatch[1]) {
          // Replace the hardcoded text with the extracted value
          element.textContent = valueMatch[1];
        }
      } catch (e) {
        console.error('Error parsing metafield JSON:', e);
      }
    }
  });
});
